import { SelectionModel } from "@angular/cdk/collections";
import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
} from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { fuseAnimations } from "@fuse/animations";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";

import { PageOrdenCompraDTO } from "app/main/apps/shared/interfaces/page-orden-compra.interface";
import { OrdenCompraDTO } from "app/main/apps/shared/models/orden-compra.model";
import { OrdenesCompraService } from "app/main/apps/shared/services/rest/orden-compra.service";
import { NotificacionesService } from "app/main/apps/shared/services/rest/notificaciones.service";
import { merge, of, Subject, Subscription } from "rxjs";
import { OnDestroy } from "@angular/core";
import {
    catchError,
    filter,
    map,
    switchMap,
    takeUntil,
    tap,
} from "rxjs/operators";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { HelpersService } from "app/main/apps/shared/services/util/helpers.service";
import { DialogReporteExcelComponent } from "../dialog-reporte-excel/dialog-reporte-excel.component";
import { DialogService } from "app/main/apps/shared/services/rest/dialog.service";
import { MenuUsuarioService } from "app/main/apps/shared/services/util/menu-usuario.service";

@Component({
    selector: "app-tabla-oocc",
    templateUrl: "./tabla-oocc.component.html",
    styleUrls: ["./tabla-oocc.component.scss"],
    animations: fuseAnimations,
})
export class TablaOoccComponent implements OnInit, OnDestroy {
    esSupervisor: boolean = false;
    esEncargado: boolean = false;
    esRepresentante: boolean = false;
    ooccMismoCliente: boolean;

    @Input() total: number;
    @Input() oocc: OrdenCompraDTO[];
    @Output() buscarMas: EventEmitter<void> = new EventEmitter();
    @Output() asociarFacturaEvent: EventEmitter<any> = new EventEmitter();
    @Output() verOOTTEvent: EventEmitter<any> = new EventEmitter();
    @Output() asociarRocGesEvent: EventEmitter<any> = new EventEmitter();
    @Output() asociarInformeEvent: EventEmitter<number> = new EventEmitter();

    dataSource: MatTableDataSource<OrdenCompraDTO>;
    displayedColumns = [
        "select",
        "numero",
        "documento",
        "fecha",
        "nombre",
        "nrrut",
    ];
    selection = new SelectionModel<any>(true, []);

    @ViewChild(MatPaginator, { static: true })
    paginator: MatPaginator;

    @ViewChild(MatSort, { static: true })
    sort: MatSort;

    @ViewChild("filter", { static: true })
    filter: ElementRef;
    subscripciones: Subscription;
    resultsLength = 0;
    private _unsubscribeAll: Subject<any>;
    constructor(
        private _ordenesCompraSrvc: OrdenesCompraService,
        private _fuseProgressBarService: FuseProgressBarService,
        private _helpersSrvc: HelpersService,
        private _notificacionSrvc: NotificacionesService,
        private _dialogSrvc: DialogService,
        public _menuUsuarioSrvc: MenuUsuarioService
    ) {
        this.ooccMismoCliente = true;
        this.subscripciones = new Subscription();
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {
        this.esSupervisor = this._menuUsuarioSrvc.esSupervisor();
        this.esEncargado = this._menuUsuarioSrvc.esEncargado();
        this.esRepresentante = this._menuUsuarioSrvc.esRepresentante();

        this.dataSource = new MatTableDataSource(this.oocc);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.subscripciones.add(
            this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0))
        );

        setTimeout(() => {
            this.tableChange();
        });
    }

    tableChange() {
        this.resultsLength = this.total;
        merge(
            // this.sort.sortChange.pipe(
            //     tap((data) => console.log("refreh sort"))
            // ),
            this.paginator.page.pipe(
                tap((data) => {
                    this.selection.deselect();
                    this.selection.clear();
                })
            ),
            this._ordenesCompraSrvc.ooccRefresh$.pipe(
                tap((data) => {
                    this.selection.deselect();
                    this.selection.clear();
                }),
                filter(
                    (refresh) => refresh //filtro para ordenesCompraRefresh$, merge se activa solo si el valor emitido es true, para evitar dobles llamadas
                )
            )
        )
            .pipe(
                // startWith({}),
                takeUntil(this._unsubscribeAll),

                switchMap((filtros) => {
                    //console.log(filtros);
                    this._fuseProgressBarService.show();
                    this._ordenesCompraSrvc.setPaginaActual(
                        this.paginator.pageIndex
                    );
                    this._ordenesCompraSrvc.setCantidaResultadosPorPagina(
                        this.paginator.pageSize
                    );
                    this._ordenesCompraSrvc.setCampoOrden(this.sort.active);
                    this._ordenesCompraSrvc.setOrden(this.sort.direction);

                    this.buscarMas.emit();
                    //return this.buscar();
                    return this._ordenesCompraSrvc.ordenesChanged$;
                }),
                map((data: PageOrdenCompraDTO) => {
                    // Flip flag to show that loading has finished.

                    this._fuseProgressBarService.hide();

                    //this.total = data.totalElements;
                    /*this._ordenesCompraSrvc.setTotalDeResultados(
                        data.totalElements
                    );*/

                    this.resultsLength = data.totalElements;

                    return data.content;
                }),
                catchError(() => {
                    this._fuseProgressBarService.hide();
                    // Catch if the GitHub API has reached its rate limit. Return empty data.

                    return of([]);
                })
            )
            .subscribe((data: OrdenCompraDTO[]) => {
                this.oocc = data;
                this.dataSource = new MatTableDataSource(this.oocc);
            });
        //);
    }

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected === numRows;
    }

    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle() {
        this.isAllSelected()
            ? this.selection.clear()
            : this.dataSource.data.forEach((row) => this.selection.select(row));
    }

    /** The label for the checkbox on the passed row */
    checkboxLabel(row?: any): string {
        if (!row) {
            return `${this.isAllSelected() ? "select" : "deselect"} all`;
        }
        return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${
            row.position + 1
        }`;
    }

    asociarFactura() {
        this.asociarFacturaEvent.emit(this.selection.selected);
        //this.selection.clear();
    }

    verOOTT(oott) {
        this.verOOTTEvent.emit(oott);
    }

    asociarRocGes(idOOCC: number, numeroGes: string) {
        this.asociarRocGesEvent.emit({
            idOOCC: idOOCC,
            numeroGes: numeroGes,
            nuevo: true,
        });
    }

    modificarRocGes(idOOCC: number, numeroGes: string) {
        this.asociarRocGesEvent.emit({
            idOOCC: idOOCC,
            numeroGes: numeroGes,
            nuevo: false,
        });
    }

    asociarInforme(id: number) {
        this.asociarInformeEvent.emit(id);
    }

    toggleSelect(event: MatCheckboxChange, oc: OrdenCompraDTO) {
        event ? this.selection.toggle(oc) : null;
        if (this.selection.selected.length >= 1) {
            this.ooccMismoCliente = this._helpersSrvc.verificaChecboxMismoPadre(
                this.selection,
                oc.idCliente,
                "idCliente",
                event.checked
            );
            if (!this.ooccMismoCliente) {
                this._notificacionSrvc.mostrarNotificacion(
                    "Todas las OOCC seleccionadas deben pertenecer al mismo cliente",
                    "info"
                );
            }
        }
    }

    abrirConsultaReporte() {
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogReporteExcelComponent,
            "clase-dialog",
            "700px"
        );
    }

    bajarInforme(idOOCC: number) {
        //console.log("llego a bajar informe");
        //console.log(idOOCC);
        this._ordenesCompraSrvc.fetchInforme(idOOCC).subscribe((blob) => {
            const a = document.createElement("a");
            let url = window.URL.createObjectURL(blob);
            a.href = url;
            a.setAttribute("download", "InformeOOCC_" + idOOCC);
            a.download;
            a.click();
        });
    }

    anular(idOOCC: number) {}
    ngOnDestroy() {
        this.subscripciones.unsubscribe();
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
